export enum AuthActionTypes {
  Login = '[Login] Action',
  Logout = '[Logout] Action',
  Register = '[Register] Action',
  SignUp = '[SignUp] Action',
  SignUpSuccess = '[SignUpSuccess] Action',
  SignUpError = '[SignUpError] Action',
  UserRequested = '[Request User] Action',
  UserLoaded = '[Load User] Auth API',
  LocationChange = '[LocationChange] Action',
  SetUserPlan = '[SetUserPlan] Action',
  SetExpiredPlanError = '[SetExpiredPlanError] Action',
  SetConnectionError = '[SetConnectionError] Action',
  AdminFetchListUser = '[AdminFetchListUser] Action',
  UpdateListUser = '[UpdateListUser] Action',
  SelectUser = '[SelectUser] Action',
  UpdateResults = '[UpdateResults] Action',
  DisableSendButtonState = '[DisableSendButtonState] Action',
  SetFetchingRecordState = '[SetFetchingRecordState] Action',
  SetDownloadingCSVState = '[SetDownloadingCSVState] Action',
  RequestCsv = '[RequestCsv] Action',
  FetchCsv = '[FetchCsv] Action',
  DeleteCsv = '[DeleteCsv] Action',
  DeleteReportSuccess = '[DeleteReportSuccess] Action',
  UpdateCsvData = '[UpdateCsvData] Action',
  RowClicked = '[RowClicked] Action',
  FetchSearchTerms = '[FetchSearchTerms] Action',
  signUpError = '[signUpError:] Action',
  forgotPassError = '[forgotPassError:] Action',
  enableLoading = '[enableLoading]: Action',
  disableLoading = '[disableLoading]: Action',
  saveUser = '[saveUser] Action',
  UpdateIsFetchingCsvData = '[UpdateIsFetchingCsvData] Action',
  FetchAsinsAnalysis = '[FetchAsinsAnalysis] Action',
  UpdateResultsAsinsAnalysis = '[UpdateResultsAsinsAnalysis] Action',
  FetchAsinsDetails = '[FetchAsinsDetails] Action',
  UpdateAsinsDetails = '[UpdateAsinsDetails] Action',
  UpdateRequestError = '[UpdateRequestError] Action',
  FetchAsinPriceDetails = '[FetchAsinPriceDetails] Action',
  UpdateAsinPriceDetails = '[UpdateAsinPriceDetails] Action',
  FetchUserDetails = '[FetchUserDetails] Action',
  SetUserDetails = '[SetUserDetails] Action',
  SetUserPlanFromDB = '[SetUserPlanFromDB] Action',
  SetSettingsOverview = '[SetSettingsOverview] Action',
  SetSettingsKeywordRank = '[SetSettingsKeywordRank] Action',
  GetGoogleAuthUrl = '[GetGoogleAuthUrl] Action',
  GetAmazonAdvertisingAuthUrl = '[GetAmazonAdvertisingAuthUrl] Action',
  RevokeToken = '[RevokeToken] Action',
  RevokeTokenSuccess = '[RevokeTokenSuccess] Action',
  RevokeAmazonAdvertisingAccount = '[RevokeAmazonAdvertisingAccount] Action',
  RevokeAmazonAdvertisingSuccess = '[RevokeAmazonAdvertisingSuccess] Action',
  RevokeAmazonSellerIntegration = '[RevokeAmazonSellerIntegration] Action',
  RevokeAmazonSellerIntegrationSuccess = '[RevokeAmazonSellerIntegrationSuccess] Action',
  SetParentEmail = '[SetParentEmail] Action',
  SetAccessDeniedError = '[SetAccessDeniedError] Action',
  UpdateAccountName = '[UpdateAccountName] Action',
  UpdateConnectionName = '[UpdateConnectionName] Action',
  UpdateConnectionNameSuccess = '[UpdateConnectionNameSuccess] Action',
  GetUserSettings = '[GetUserSettings] Action',
  SetUserSettings = '[SetUserSettings] Action',
  UpdateUserSettings = '[UpdateUserSettings] Action',
  ForgotPassword = '[ForgotPassword] Action',
  ForgotPasswordSuccess = '[ForgotPasswordSuccess] Action',
  ForgotPasswordConfirm = '[ForgotPasswordConfirm] Action',
  ForgotPasswordConfirmSuccess = '[ForgotPasswordConfirmSuccess] Action',
  ChangePassword = '[ChangePassword] Action',
  ChangePasswordSuccess = '[ChangePasswordSuccess] Action',
  accountSettingsError = '[accountSettingsError] Action',
  UpdateAccountSettings = '[UpdateAccountSettings] Action',
  UpdateAccountSettingsSuccess = '[UpdateAccountSettingsSuccess] Action',
  VerifyEmailChange = '[VerifyEmailChange] Action',
  VerifyEmailChangeSuccess = '[VerifyEmailChangeSuccess] Action',
  VerifyEmailChangeError = '[VerifyEmailChangeError] Action',
}
